/***
 * Convert arrays of errors from backend to multiline
 ***/
export function flat_errors(errors) {
  let flat = {};
  for (const [key, value] of Object.entries(errors)) {
    if (Array.isArray(value)) {
      flat[key] = value.join("\r\n");
    } else if (typeof value === "object") {
      flat[key] = flat_errors(value);
    } else {
      flat[key] = value;
    }
  }
  return flat;
}

export function bad_request(error) {
  return error.response && error.response.status === 400;
}

export function detail_response(error) {
  return error.response.data.detail;
}

export function notFound(error) {
  return error.response && error.response.status === 404;
}
